export default __webpack_public_path__ + "static/media/draper-associates.08bbac5f.svg";